import React from 'react';
import styles from './AgGridTable.scss';
var rows = Array(20).fill('');
var columns = Array(10).fill('');
export var CustomLoadingOverlay = function CustomLoadingOverlay(props) {
  return React.createElement("div", {
    className: styles.loadingOverlay
  }, rows.map(function (item, i) {
    return React.createElement("div", {
      key: "loading-skeleton-row-".concat(i),
      className: styles.loadingRow
    }, columns.map(function (value, j) {
      return React.createElement("div", {
        className: styles.loadingCell,
        key: "row-loading-cell-".concat(j)
      }, React.createElement("div", {
        className: styles.pulse
      }));
    }));
  }));
};